// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/Package/components/ProductLocation/index.css
// module id = 2284
// module chunks = 0